export class AppConstant {
    public static AUTH_TOKEN_NAME = 'wts-authenticationToken';
}